import type { Reducer } from 'react'

import type { Actions } from './actions'
import { ActionType } from './actions'
import type { State } from './state'

const reducer: Reducer<State, Actions> = (state, action) => {
  switch (action.type) {
    case ActionType.NewMessage: {
      return { ...state, message: action.payload }
    }
    case ActionType.NewEvent: {
      return { ...state, event: action.payload }
    }
    case ActionType.NewUserGroupCallbacks: {
      return { ...state, userGroupCallbacks: action.payload }
    }
  }
}

export default reducer
